import React, { Component } from "react";
import { withListSensors } from "../../../shared/containers/containerListSensors";
import { states } from "../../../reducers/queriesStates";
import { withDevices } from "../../../shared/containers/containerDevices";
import CmsConnectorSensorTools from "./CmsConnectorSensorTools";

class CmsConnectedSensors extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    const { listSensorsDataState, onGetListSensors } = this.props;

    if (listSensorsDataState !== states.READY) {
      onGetListSensors();
    }
  }

  render() {
    return (
      <div>
        <CmsConnectorSensorTools />
      </div>
    );
  }
}

export default withDevices(withListSensors(CmsConnectedSensors));
